/**
 * Shared styles for registration form inputs, selects, and buttons.
 * Modern, rounded, with smooth transitions.
 */
import type { SxProps, Theme } from "@mui/material";

const focusRing = "0 0 0 2px rgba(111, 73, 201, 0.25)";

export const registrationInputSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "5px",
    transition:
      "box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease",
    backgroundColor: "background.paper",
    "& fieldset": {
      borderRadius: "5px",
      borderWidth: "1px",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease"
    },
    "&:hover fieldset": {
      borderColor: "grey.400"
    },
    "&.Mui-focused fieldset": {
      borderColor: "primary.main",
      boxShadow: focusRing
    },
    "&.Mui-error fieldset": {
      borderColor: "error.main"
    }
  }
};

export const registrationSelectSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "5px",
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    "& fieldset": {
      borderRadius: "5px",
      borderWidth: "1px",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease"
    },
    "&:hover fieldset": { borderColor: "grey.400" },
    "&.Mui-focused fieldset": {
      borderColor: "primary.main",
      boxShadow: focusRing
    }
  }
};

export const registrationFieldMotion = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.3, ease: "easeOut" as const }
};
